import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import Picture from '@cotyorg/ccx-atoms/Picture';

export const generateContentColumnClassNames = ({ isFullWidth, details }) => classNames(
  'cell',
  'xsmall-16',
  {
    'large-8': isFullWidth && !!details,
  },
);

export const generateDetailsColumnClassNames = ({ isFullWidth }) => classNames(
  'cell xsmall-16',
  {
    'large-7 large-offset-1': isFullWidth,
  },
);

export const generateDetailsListClassNames = ({ style }) => classNames(
  'product-details-tab__list',
  {
    'grid-x grid-padding-x': style === 'icons',
  },
);

export const generateDetailsListItemClassNames = ({ style, isFullWidth }) => classNames(
  'product-details-tab__list-item',
  'flex-container align-middle',
  'cell xmall-16', {
    'medium-8': isFullWidth,
    'product-details-tab__list-item--bullets': style === 'bullets',
  },
);

const ProductDetailsTabContent = ({
  content,
  details,
  style,
  isFullWidth,
}) => (
  <div className="grid-x">
    <div className={generateContentColumnClassNames({ isFullWidth, details })}>
      { Array.isArray(content) && (
        <ul>{content.map(item => <li>{item}</li>)}</ul>
      )}
      {!Array.isArray(content) && <p>{content}</p>}
    </div>

    {details &&
      <div className={generateDetailsColumnClassNames({ isFullWidth })}>
        {Array.isArray(details) &&
          <ul className={generateDetailsListClassNames({ style })}>
            {details.map(({ icon, text }) => (
              <li
                className={generateDetailsListItemClassNames({ style, isFullWidth })}
                key={uuid()}
              >
                {style === 'icons' &&
                  <span className="product-details-tab__list-icon">
                    <Picture src={icon} alt={text} />
                  </span>
                }
                <strong>{text}</strong>
              </li>
            ))}
          </ul>
        }
      </div>
    }
  </div>
);

ProductDetailsTabContent.propTypes = {
  content: PropTypes.string,
  details: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string,
    text: PropTypes.string,
  })),
  style: PropTypes.oneOf(['icons', 'bullets']),
  isFullWidth: PropTypes.bool,
};

export default ProductDetailsTabContent;
